(function($, _) {

  /**
   * Navbar Resizer jQuery plugin.
   *
   * Resize navbar elements overflowing extra elements in a dropdown menu.
   */
  $.navbarResizer = function(element, options) {

    var defaults = {
      floatBreakpoint: 768,
      container: '',
      extraSelector: '.navbar-resizer-extra',
      minElements: 0,
      ignoreExtra: false
    }

    var plugin = this;

    plugin.settings = {};

    var $element = $(element),
         element = element,
         $window = $(window),
         $container,
         $extraElement,
         $extraContainer
    ;

    plugin.init = function() {
      // Merge all settings, default, data-* and javascript options.
      plugin.settings = $.extend({}, defaults, $element.data(), options);

      // Find the container.
      $container = (plugin.settings.container !== '') ? $element.find(plugin.settings.container): $element;

      // Set some needed CSS properties.
      // NB: Important for hte plugin to work.
      $element.css({'position': 'relative'});

      // Store the extra tick.
      $extraElement = $element.find(plugin.settings.extraSelector);
      $extraContainer = ($extraElement.find('.dropdown-menu').length > 0) ? $extraElement.find('.dropdown-menu'): $extraElement; // @TODO options

      // Make a first resize.
      plugin.resize();

      // Register a handler for window resizing.
      $(window).on('resize', _.debounce(function (event) {
          // Do stuff.
          plugin.resize();
      }, 100));
    }

    /**
     * Perform the resizing of this element.
     */
    plugin.resize = function()
    {
      // Reset the navbar items.
      plugin.resetElements();

      // Trigger some event before actually resizing/hiding things..
      $element.trigger(
          $.Event('resizing.jq.navbar-resizer', {}),
          {
            'plugin': plugin
          }
      );

      if ($window.width() < plugin.settings.floatBreakpoint) {
        // We're in mobile/responsive view... skip.
        $extraElement.addClass('navbar-resizer-empty');
        $extraElement.removeClass('navbar-resizer-visible');
        return;
      }

      var navbarItems = plugin.findNavbarItems().toArray();
      var nb = 0;
      while (true === plugin.detectOverflow(navbarItems.length, $extraElement) && navbarItems.length > 0) {
        var $navbarItem = $(navbarItems.pop());

        $renderedNavbarItem = plugin.renderElement($navbarItem.detach());
        $renderedNavbarItem.prependTo($extraContainer);

        // Processed elements ++.
        ++nb;
      }

      if (0 === $extraContainer.children().length) {
        $extraElement.addClass('navbar-resizer-empty');
        $extraElement.removeClass('navbar-resizer-visible');
      } else {
        $extraElement.removeClass('navbar-resizer-empty');
        $extraElement.addClass('navbar-resizer-visible');
      }

      // Trigger some event after everything has been done.
      $element.trigger(
          $.Event('resized.jq.navbar-resizer', {}),
          {
            'plugin': plugin
          }
      );
    }

    /**
     * Detect if the given element is overflowing.
     *
     * @param  jQuery $navbarItem
     *
     * @return boolean
     */
    plugin.detectOverflow = function (i, $navbarItem)
    {
      // Compute the remaining space available.
      var remainingSpace = plugin.computeOverflowBreakpoint(),
          breakpointTop = parseInt($element.css('padding-top'), 10)
      ;

      var extraOffset = $navbarItem.offset(),
          elementOffset = $container.offset(),
          currentPosition = {
            'top': extraOffset.top - elementOffset.top,
            'left': extraOffset.left - elementOffset.left,
          };

      // Return true if element overflows.
      return (currentPosition.top > breakpointTop || (currentPosition.left + $navbarItem.outerWidth()) > remainingSpace);
    }

    plugin.computeOverflowBreakpoint = function ()
    {
      // Get the parent of the container to compute the available size.
      var availableSpace = $container.parent().width();

      if (false === plugin.settings.ignoreExtra && $extraElement.hasClass('.navbar-resizer-visible')) {
        // Return the total space minus the width of the extra element.
        return (availableSpace - $extraElement.outerWidth());
      }
      return availableSpace;
    }

    plugin.renderElement = function ($item)
    {
      return $item;
    }

    plugin.unrenderElement = function ($item)
    {
      return $item;
    }

    plugin.resetElements = function ()
    {
      // Force relayout for web browser.
      // http://stackoverflow.com/questions/5974323/jquery-get-the-offset-of-hidden-element
      $extraContainer.children().each(function (i, e) {
        $resettedElement = plugin.unrenderElement($(e).detach());
        $resettedElement.insertBefore($extraElement);
      });

      // Remove all state classes to ensure the navbar-resizer-extra is visible.
      $extraElement.removeClass('navbar-resizer-empty');
      $extraElement.removeClass('navbar-resizer-visible');
    }

    plugin.findNavbarItems = function ()
    {
      // Return all navbar items.
      return $container.children().filter(function(i, e) {
        // Every element but not the extra element.
        return ($(e)[0] !== $extraElement[0]);
      });
    }

    plugin.getExtraElement = function ()
    {
      return $extraElement;
    }

    plugin.init();
  }

  $.fn.navbarResizer = function(options) {
    return this.each(function() {
      if (undefined == $(this).data('navbarResizer')) {
        var plugin = new $.navbarResizer(this, options);
        $(this).data('navbarResizer', plugin);
      }
    });
  }

  /**
   * DATA-* ATTRIBUTES API
   *
   * Use data-* attributes to enable/configure your sheeper components.
   */
  $(document).ready(function() {
    $('[data-toggle="navbar-resizer"]').navbarResizer({});
  });
})(jQuery, _);
